// extracted by mini-css-extract-plugin
export default {"tagContainer":"LabReportProcessingStatusComponent_tagContainer__yeP1B"};